<template>
<v-container>
  <v-alert :type="typeAlert" v-model="alertGPS">
     {{ alertText }}
  </v-alert>
<qrcode-stream v-if="qrcodeScanner" @decode="onDecode"></qrcode-stream>

</v-container>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  props: ['onDecode', 'qrcodeScanner', 'typeAlert', 'alertText', 'alertGPS'],
  components: {QrcodeStream},

  data: () => ({


  }),
  methods: {

  }
 }
</script>
